export default __webpack_public_path__ + "static/media/hydro.e945463f.jpg";